import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { assert } from '../../assert';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaHaspopupSDK } from './types';

const ariaHaspopupSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaHaspopupSDK
> = ({ setProps, props }) => ({
  get hasPopup() {
    return props.ariaAttributes?.haspopup;
  },
  set hasPopup(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        haspopup: assert.isNil(value) ? undefined : String(value),
      },
    });
  },
});

export const createAriaHaspopupSDK = withValidation(ariaHaspopupSDKFactory, {
  type: ['object'],
  properties: {
    hasPopup: {
      type: ['string', 'boolean'],
      enum: ['false', 'true', 'menu', 'dialog', 'grid', 'listbox', 'tree'],
    },
  },
});
